import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {useSelector} from "react-redux";
import {AppState, SalesType} from "../../../types/redux";

const useStyles = makeStyles((theme: Theme) => ({
	descriptionListItem: {
		padding: theme.spacing(0, 2),
	},
}));

const ProductDescriptionList = () => {
	const salesTypes = useSelector<AppState, SalesType[]>( state => state.user.salesType )||[];
	let isNotEp = !salesTypes.includes(SalesType.EPK) && !salesTypes.includes(SalesType.EPH)

	const classes = useStyles();
	const { t } = useTranslation();
	if (isNotEp) return (
		<List>
			<ListItem className={classes.descriptionListItem}>
				<ListItemIcon>
					<CheckIcon color="primary" fontSize="large" />
				</ListItemIcon>
				<ListItemText primary={t('home.kpp.description.li1')} />
			</ListItem>
			<ListItem className={classes.descriptionListItem}>
				<ListItemIcon>
					<CheckIcon color="primary" fontSize="large" />
				</ListItemIcon>
				<ListItemText primary={t('home.kpp.description.li2')} />
			</ListItem>
			<ListItem className={classes.descriptionListItem}>
				<ListItemIcon>
					<CheckIcon color="primary" fontSize="large" />
				</ListItemIcon>
				<ListItemText primary={t('home.kpp.description.li3')} />
			</ListItem>
		</List>)
	else return (
		<List>
			<ListItem className={classes.descriptionListItem}>
				<ListItemIcon>
					<CheckIcon color="primary" fontSize="large" />
				</ListItemIcon>
				<ListItemText primary={t('home.kpp.description.li1')} />
			</ListItem>
			<ListItem className={classes.descriptionListItem}>
				<ListItemIcon>
					<CheckIcon color="primary" fontSize="large" />
				</ListItemIcon>
				<ListItemText primary={t('home.kpp.description.li2bank11')} />
			</ListItem>
		</List>
	);
};

export default ProductDescriptionList;
